import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Timer from './Timer/index';
import TimerCounter from './Timer/TimerCounter';
import WarningNotification from './Timer/WarningNotification';

/**
 * UI controller that starts the Timer functionality.
 * It also recieve updates from the Timer component
 * and notify it parent about the timeElapsed
 */
class QuizTimer extends PureComponent {
  static displayName = 'QuizTimer';

  static QUIZ_OVERDUE_STATUS = 'Overdue';

  static propTypes = {
    timerInfo: PropTypes.object.isRequired,
    isSoftTime: PropTypes.bool.isRequired,
    onShowModal: PropTypes.func.isRequired,
    timer: PropTypes.string,
    checkTimeExtension: PropTypes.func,
    checkTimeExtensionInterval: PropTypes.number,
    onTimerExpiring: PropTypes.func,
    hasControls: PropTypes.bool,
    learnosityData: PropTypes.shape({
      activity: PropTypes.object,
      items: PropTypes.object,
      currentItem: PropTypes.object,
      app: PropTypes.object,
    }),
  };

  static defaultProps = {
    timer: '00:00:00',
    checkTimeExtension: () => {},
    checkTimeExtensionInterval: 30000,
    onTimerExpiring: null,
    hasControls: false,
  };

  state = {
    timerTickUpdate: {},
    isRunning: false,
  };

  /**
   * callback to the Timer UI when
   * the totalTime has expired.
   * @params exhausted
   **/
  onTimerEnd = () => {
    const { timer, onShowModal } = this.props;
    if (timer) {
      onShowModal('ExpiredTime');
    }
  };

  onTimerTick = (timerUpdate) => {
    this.setState({ timerTickUpdate: { ...timerUpdate } });
  };

  /**
   * Timer control change show/hide callback
   * */
  onTimerControlChange = (show) => {
    this.setState({
      isRunning: show,
    });
  };

  render() {
    const {
      timerInfo,
      isSoftTime,
      checkTimeExtension,
      checkTimeExtensionInterval,
      onTimerExpiring,
      hasControls,
      learnosityData,
    } = this.props;
    const { timerTickUpdate, isRunning } = this.state;
    const { showWarning } = timerTickUpdate;
    const timerProps = {
      ...timerInfo,
      isSoftTime,
      checkTimeExtension,
      checkTimeExtensionInterval,
      onTimerExpiring,
      onTimerEnd: this.onTimerEnd,
      onTimerUpdate: this.onTimerTick,
      isRunning,
      learnosityData,
    };
    const { submissionStatus } = timerInfo || {};
    const isOverdue = submissionStatus === QuizTimer.QUIZ_OVERDUE_STATUS;
    return (
      <Timer {...timerProps}>
        <TimerCounter
          {...timerTickUpdate}
          hasControls={hasControls}
          isRunning={isRunning}
          timerControlChange={this.onTimerControlChange}
        />
        {!isOverdue && <WarningNotification canShowWarning={showWarning} />}
      </Timer>
    );
  }
}
export default QuizTimer;
